import { ITEM_KINDS, STATES } from '../../../constants';

export function ForwardMailConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_FORWARD_MAIL, {
    abstract: true,
    url: '/forward-mail',
    data: {
      permissions: 'signedIn',
      moveItem: {
        type: ITEM_KINDS.FORWARD_MAIL,
        // Determines whether or not there can be more than 1 of these move items
        singleton: false,
      },
      afterVerifyState: STATES.STEP_FORWARD_MAIL_LIST,
      beforeVerifyState: STATES.STEP_FORWARD_MAIL_NEW,
    },
    title: 'Forward Your Mail',
    // `when` here is used for breadcrumb directive
    // TODO: Remove once we replace with `u-breadcrumb`
    when: STATES.STEP_FORWARD_MAIL_LIST,
    // Need the titleBar on this state to allow the `app.verify`
    // state to show it
    titleBar: {
      title: 'Forward Your Mail',
      save: 'Average Time Saved: 20 minutes',
      icon: 'mail',
    },
  });
}
